<template>
   <Reports :api-func="api" :navigator-id="appId"/>
</template>

<script>
import { Reports } from "@infoenergo/asuse-reports-ui"
import { api } from '@/service/http';
import { getCookie } from '@/utils/cookies';
export default {
  name: 'report-navigator',
  components: {
    Reports
  },
  data() {
    return {
      api,
      appId: getCookie('app')
    }
  },
};
</script>
